import { api } from '@/api'

export interface UpdateServiceProviderPayload {
  name: string
  slug: string
  description?: string | null
  logo_url?: string | null
  website_url?: string | null
  is_active: boolean
}

export function updateServiceProviderAction(id: string, payload: UpdateServiceProviderPayload) {
  return api.v2.put(`/service-providers/${id}`, payload as unknown as Record<string, unknown>)
}
